import actions from '../actions/FavoritesActions';

const {
    RESET_MODAL_STATE,
    SET_MODAL_OPEN,
    SET_OPEN_MODAL_TYPE,
    SET_SHOW_ERROR_SUCCESS_MODAL,
} = actions;

const modalState = (state = {}, payload) => {
    switch (payload.type) {
        case RESET_MODAL_STATE:
            return {
                modalOpen: false,
                openModalType: '',
            };
        case SET_MODAL_OPEN:
            return { ...state, modalOpen: payload.modalOpen };
        case SET_OPEN_MODAL_TYPE:
            return { ...state, openModalType: payload.openModalType };
        case SET_SHOW_ERROR_SUCCESS_MODAL: {
            return { ...state, showErrorSuccessModal: payload.showErrorSuccessModal };
        }
        default:
            return state;
    }
};

export default modalState;
